import PropTypes from "prop-types";

import {
  AddressStatusChangeActivityV2,
  GroupTextActivityV2,
  TextActivityV2,
  ShowingRequestActivityV2,
  HomeValueActivityV2,
  ViewedPropertyActivityV2,
  QuestionsActivityV2,
  LeadTransferActivityV2,
  NewLeadActivityV2,
  FavPropertyActivityV2,
  SavedSearchActivityV2,
  ReturnSiteActivityV2,
  NoteMentionActivityV2,
  NewTaskActivityV2,
  SubmittedFormActivityV2,
  SellingPageVisitedActivityV2,
  ListingInquiryActivityV2,
  GabbiAgentNeededActivityV2,
} from "./ActivitiesV2";

export const STYLES = {
  pipe: "tw-border-r tw-border-l-0 tw-border-t-0 tw-border-b-0 tw-border-solid tw-border-gray-10 tw-h-[16px]",
  row: "tw-text-14d tw-flex tw-gap-8px",
  contentContainer: "tw-flex tw-flex-col tw-gap-4px tw-pl-12px",
  contentContainer2: "tw-flex tw-gap-20px tw-justify-between",
  textThemed: (isPlace) => (isPlace ? "tw-text-semantic-blue-100" : "tw-text-teal"),
  bgThemed: (isPlace) => (isPlace ? "tw-bg-semantic-blue-100" : "tw-bg-teal"),
  badgeThemed: (isPlace) =>
    isPlace ? "tw-bg-[#E6EDFA] tw-text-[#2454B2]" : "tw-bg-[#EEF9F9] tw-text-brand-success",
  lineClamp3: "tw-overflow-hidden tw-text-ellipsis tw-break-words tw-line-clamp-3 tw-text-gray-75",
  // Hidding until we have proper data (call, lisitng and report links)
  btnContainer: "tw-flex tw-gap-8px tw-mt-12px",
  btn: "tw-flex tw-items-center tw-gap-4px",
};

export const activityCommonPropTypes = {
  activity: PropTypes.shape().isRequired,
  Icon: PropTypes.func,
  children: PropTypes.node,
  childContainerClass: PropTypes.string,
  onReadChange: PropTypes.func,
  SideContent: PropTypes.node,
};

export const activityCommonDefaultProps = {
  onReadChange: () => {},
  childContainerClass: "",
  SideContent: null,
  queryParams: "",
};

export const includeFeatureFlaggedKeys = (featureFlag, activities) => (featureFlag ? activities : {});

export const BATCH_1_ACTIVITIES = {
  assigned_task: { component: NewTaskActivityV2, category: "crm" },
  cash_offer_submitted: { component: SubmittedFormActivityV2, category: "requests" },
  cma_requested: { component: SubmittedFormActivityV2, category: "requests" },
  contact_us: { component: SubmittedFormActivityV2, category: "requests" },
  contact_form_ask_a_question: { component: SubmittedFormActivityV2, category: "requests" },
  group_message: { component: GroupTextActivityV2, category: "text" },
  home_value_submitted: { component: HomeValueActivityV2, category: "requests" },
  lead_pond_contact_form_questions_about: { component: QuestionsActivityV2, category: "requests" },
  lead_pond_home_value_submitted: { component: HomeValueActivityV2, category: "requests" },
  lead_pond_home_value: { component: HomeValueActivityV2, category: "requests" },
  lead_pond_mention: { component: NoteMentionActivityV2, category: "crm" },
  lead_pond_property_viewed_x_times: { component: ViewedPropertyActivityV2, category: "web" },
  lead_pond_registration: { component: LeadTransferActivityV2, category: "crm" },
  lead_pond_return_after_30_days: { component: ReturnSiteActivityV2, category: "web" },
  lead_pond_schedule_showing: { component: ShowingRequestActivityV2, category: "requests" },
  lead_registration: { component: NewLeadActivityV2, category: "crm" },
  lead_return_after_30_days: { component: ReturnSiteActivityV2, category: "web" },
  lead_transfer: { component: LeadTransferActivityV2, category: "crm" },
  mention: { component: NoteMentionActivityV2, category: "crm" },
  property_viewed_x_times: { component: ViewedPropertyActivityV2, category: "web" },
  question_submitted: { component: QuestionsActivityV2, category: "requests" },
  saved_property: { component: FavPropertyActivityV2, category: "web" },
  saved_search: { component: SavedSearchActivityV2, category: "web" },
  schedule_showing: { component: ShowingRequestActivityV2, category: "requests" },
  sell_my_home_submitted: { component: SubmittedFormActivityV2, category: "requests" },
  text_message: { component: TextActivityV2, category: "text" },
  unlock_equity_requested: { component: SubmittedFormActivityV2, category: "requests" },
  updated_home_value: { component: HomeValueActivityV2, category: "requests" },
  valuation_requested: { component: SubmittedFormActivityV2, category: "requests" },
  selling_page_visited: { component: SellingPageVisitedActivityV2, category: "web" },
  feedback_submitted: { component: SubmittedFormActivityV2, category: "requests" },
  contact_form_questions_about: { component: ListingInquiryActivityV2, category: "requests" },
};

export const ACTIVITIES_ADDRESS_LIST_FF = {
  lead_property_status_change: { component: AddressStatusChangeActivityV2, category: "crm" },
};

export const ACTIVITIES_FEED_TEST_FF = {
  sell_my_home_submitted_market_report: { component: SubmittedFormActivityV2, category: "requests" },
  adjusted_equity_calculator: { component: SubmittedFormActivityV2, category: "requests" },
  prequalification_request: { component: SubmittedFormActivityV2, category: "requests" },
  get_prequalified: { component: SubmittedFormActivityV2, category: "requests" },
  contact_form_general: { component: SubmittedFormActivityV2, category: "requests" },
};

export const ACTIVITIES_GABBI_FF = {
  gabbi_agent_needed: { component: GabbiAgentNeededActivityV2, category: "ai" },
};
